module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.0@core-js/library/modules/_library.js
// module id = 107
// module chunks = 0 1